import styled from "styled-components";
import { useRef, useEffect } from "react";
import { useInView } from 'react-intersection-observer';
import anime from 'animejs';
import { mq } from "../util/media";

import Button from "../Button";
import LearnMoreButton from "../LearnMoreButton";
import GradientText from "../GradientText";
import SectionWrapper from "../SectionWrapper";
import SectionTitle from "../SectionTitle";

import ChartIcon from "../../images/chart.svg";
import ShieldIcon from "../../images/shield.svg";
import ClockIcon from "../../images/clock.svg";
import MenuIcon from "../../images/menu.svg";


const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;

  justify-content: center;


  ${mq.gt.xs} {
    gap: 2rem;
    justify-content: flex-start;
  }
`

const InfoWrapper = styled.div`
  margin: 5rem 0;

  ${mq.lt.md} {
    margin: 45px 0;
  }

  transition: 0.7s ease-in-out;

  &.hidden {
    opacity: 0;
    transform: translateY(10%);
  }
`

const Inner = styled.div`
  display: grid;
  /* grid-template-rows: 1fr 1fr; */
  gap: 2rem;
  width: 100%;
`

const InfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 60px;

  ${mq.gt.xs} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    column-gap: 36px;
    row-gap: 26px;
    margin-top: 3.125rem;
  }

  ${mq.gt.sm} {
    column-gap: 66px;
  }


`

const GridItem = styled.div`
  letter-spacing: 0.5px;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1rem;
  background-color: #121315;
  border-radius: 1rem;
  font-size: 11px;
  padding: 1rem 1.4rem;

  align-items: center;

  span {
    line-height: 1.1;
  }

  ${mq.gt.xs} {
    font-size: 0.9rem;
    padding: 1.5rem;
    gap: 1.1rem;
  }

  ${mq.gt.md} {
    font-size: 20px;
    padding: 36px;
    gap: 2rem;
  }

`

const ImageWrapper = styled.div`
  
  width: 24px;
  aspect-ratio: 1;

  ${mq.gt.sm} {
    width: 40px;
  }

  img {
    width: 100%;
    height: 100%;
  }

`


const GridItemTitle = styled.span`
  font-weight: 860;
`


function FirstSteps() {

  const animationRef = useRef(null);

  const [textRef, textInView] = useInView({
    triggerOnce: true,
    threshold: 0.6
  });


  useEffect (() => {
    if (textInView) {
      anime({
        targets: animationRef.current.children,
        opacity: [0, 1],
        delay: anime.stagger(200),
        duration: 800,
        easing: 'linear',
      });
    }
  }, [textInView]);


  return(
    <SectionWrapper smaller>

        <Inner>

          <InfoWrapper ref={textRef} className={textInView ? "" : "hidden" }>
            <SectionTitle>Take your first step<br /> into <GradientText to="right" color1="#DA77C1" color2="#ED9381">DeFi</GradientText> with <GradientText to="right" color1="#D36DD7" color2="#F19B71">Near Treasury</GradientText></SectionTitle>
            <ButtonContainer>
              <LearnMoreButton>Learn More</LearnMoreButton>
              <Button link="/webapp" type="webapp">WebApp</Button>
            </ButtonContainer>

            <InfoGrid ref={animationRef}>
              <GridItem>
                <ImageWrapper><img src={ChartIcon} alt="" /></ImageWrapper>
                <span>
                  <GridItemTitle>High Yields:</GridItemTitle> Earn the highest stable yield in crypto with Near Treasury savings.
                </span>
              </GridItem>
              <GridItem>
                <ImageWrapper><img src={ClockIcon} alt="" /></ImageWrapper>
                <span>
                  <GridItemTitle>Flexibility:</GridItemTitle> Deposit and withdraw your savings anytime, anywhere.<br/>No minimum deposit required for maximum flexibility.
                </span>
              </GridItem>
              <GridItem>
                <ImageWrapper><img src={ShieldIcon} alt="" /></ImageWrapper>
                <span>
                  <GridItemTitle>Security:</GridItemTitle> Our highest priority is to maximize the safety of our users funds, our partner projects and our community.
                </span>
              </GridItem>
              <GridItem>
                <ImageWrapper><img src={MenuIcon} alt="" /></ImageWrapper>
                <span>
                  <GridItemTitle>Stability:</GridItemTitle> Near Treasury offers unparalleled stable interest rates for Stable Coins and other assets.
                </span>
              </GridItem>
            </InfoGrid>
            

          </InfoWrapper>      

          
        </Inner>

    </SectionWrapper>

  )
}

export default FirstSteps;